import React, { useState, useEffect, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import Lead from "../../../shared/Lead";
import { BsTelephoneInboundFill, BsTelephoneOutbound } from "react-icons/bs";
import { Task } from "../../../helpers/Contexts";
import AppointmentRequestForm from "../../forms/AppointmentRequestForm";
import RxRequestForm from "../../forms/RxRequestForm";
import OldGeneralPatientRequestForm from "../../forms/OldGeneralPatientRequestForm";
import GeneralPatientRequestForm from "../../forms/GeneralPatientRequestForm";
import InternalCommunicationForm from "../../forms/InternalCommunicationForm";
import AppointmentScheduledForm from "../../forms/AppointmentScheduledForm";
import * as CONST from "../../../helpers/Constants";
import PatientSearch from "../../PatientSearch";
import Loading from "../../../shared/Loading";
import AppointmentCompletedForm from "../../forms/AppointmentCompletedForm";
import AudioControl from "./AudioControl";
import PhoneCallButton from "./PhoneCallButton";

const CurrentCall = ({ task, dispatch, state }) => {
  const { taskValues, setTaskValues } = useContext(Task);
  const [showPatientSearch, setShowPatientSearch] = useState(false);
  const [taskType, setTaskType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [patient, setPatient] = useState(null);

  useEffect(() => {
    if (patient && taskType) {
      setLoading(true);
      dispatch({ type: "set_create_call_task", payload: { patient: patient, type: taskType } });
      setTimeout(() => {
        showPatientSearch && setShowPatientSearch(false);
        setLoading(false), 500;
      });
    }
  }, [patient]);

  return (
    <Row className="flex">
      {task.actions}
      <Col sm={8} md={9} className="task-cols pad20">
        {taskValues.editing.requested && (
          <div className="pad20">
            <Lead message="Select Task Type" />

            <br />
            <select
              name="task_type"
              onChange={(e) => {
                setTaskType(e.target.value);
                setShowPatientSearch(true);
              }}
            >
              <option value={""}>Select task type</option>
              {CONST.TASK_TYPES.map((option, i) => (
                <option key={i} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {showPatientSearch && (
              <PatientSearch
                taskHandler={(val) => {
                  setPatient(val);
                }}
              />
            )}
            {loading && <Loading message="loading" />}
            {taskType && !loading && patient && (
              <>
                <br />
                <br />
                {taskType == "Appointment Request" ? (
                  <AppointmentRequestForm
                    dispatch={dispatch}
                    state={state}
                    isCall={true}
                    formHandler={task.formHandler}
                  />
                ) : taskType == "Appointment Scheduled" ? (
                  <AppointmentScheduledForm
                    dispatch={dispatch}
                    state={state}
                    isCall={true}
                    formHandler={task.formHandler}
                  />
                ) : taskType == "Appointment Completed" ? (
                  <AppointmentCompletedForm
                    dispatch={dispatch}
                    state={state}
                    isCall={true}
                    formHandler={task.formHandler}
                  />
                ) : taskType == "General Patient Request" && state.settings.referral_request_v2_enabled == true ? (
                  <GeneralPatientRequestForm
                    dispatch={dispatch}
                    state={state}
                    task={{
                      ...state.currentTask,
                      ...state.create,
                    }}
                    isCall={true}
                    formHandler={task.formHandler}
                  />
                ) : taskType == "General Patient Request" && state.settings.referral_request_v2_enabled == false ? (
                  <OldGeneralPatientRequestForm
                    dispatch={dispatch}
                    state={state}
                    task={{
                      ...state.currentTask,
                      ...state.create,
                    }}
                    isCall={true}
                    formHandler={task.formHandler}
                  />
                ) : taskType == "Rx Request" ? (
                  <RxRequestForm
                    dispatch={dispatch}
                    task={{
                      ...state.currentTask,
                      ...state.create,
                    }}
                    isCall={true}
                    formHandler={task.formHandler}
                  />
                ) : taskType == "Internal Communication" ? (
                  <InternalCommunicationForm
                    dispatch={dispatch}
                    isCall={true}
                    task={{
                      ...state.currentTask,
                      ...state.create,
                    }}
                    formHandler={task.formHandler}
                  />
                ) : null}
              </>
            )}
          </div>
        )}

        {!taskValues.editing.requested && (
          <>
            <br />
            {task.phone_call.support_agent && (
              <small id="from">
                {task.phone_call.support_agent.first_name +
                  " " +
                  task.phone_call.support_agent.last_name}
                <br />
              </small>
            )}
            <Lead message={task.label} />
            <br />
            <div className="mt20">
              <BsTelephoneOutbound className="phone-number-icon" />
              <b>From </b>
              <PhoneCallButton phoneNumber={task.phone_call.from} />
              <BsTelephoneInboundFill className="phone-number-icon ml20" />
              <b>To </b>
              <PhoneCallButton phoneNumber={task.phone_call.to} />
            </div>
            <hr />
            {task.phone_call.recording_url && (
              <AudioControl
                url={`${task.phone_call.recording_url}`}
                id={`current-call-${ task.id }`}
                caller={task.phone_call.from}
              />
            )}{" "}
            <div className="bottom mb10">
              Created at:{" "}
              <b>
                {new Date(task.created_at).toLocaleString([], {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </b>
            </div>
          </>
        )}
      </Col>
    </Row>
  );
};
export default CurrentCall;
